module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("New category")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('category-form', {
    on: {
      "toggleIsDisabled": _vm.toggleIsDisabled,
      "readyToSave": _vm.readyToSave
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabled || _vm.getIsAddingItem
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-151bbcca"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/CategoryAdd.vue
// module id = 1280
// module chunks = 0